import { atom } from "jotai";

import { Day } from "./../gql/generated-types";

export const selectedDayAtom = atom<Day | undefined | null>(undefined);

export const todayDataAtom = atom<Day | undefined | null>(undefined);

if (process.env["NODE_ENV"] !== "production") {
  selectedDayAtom.debugLabel = "selectedDayAtom";
  todayDataAtom.debugLabel = "todayDataAtom";
}
